import {Component, OnInit, ViewChild} from "@angular/core";
import {ProtestInfoService} from "../../services/protest-info.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilerType, ProtestInfo} from "../../models/protest";
import {UserRole} from "../../models/user";
import {StateService} from "../../services/state.service";
import {EPDSFile} from "../../models/file-upload";
import {NgForm} from "@angular/forms";
import {catchError, finalize, tap, throwError} from "rxjs";
import {FileUploadService} from "../../services/file-upload.service";
import {MatSelectChange} from "@angular/material/select";
import {SidebarService} from "../../services/sidebar.service";
import {UtilService} from "../../services/util.service";
import {FileUploadComponent} from "../file-upload/file-upload.component";

@Component({
    selector: 'app-other-protest',
    templateUrl: './other-protest.component.html',
    styleUrl: './other-protest.component.scss',
    standalone: false
})
export class OtherProtestComponent implements OnInit {
  @ViewChild('protestForm') form!: NgForm;
  @ViewChild('fileUpload', { static: false }) fileUpload!: FileUploadComponent;

  a_No = '';
  typeOfProtest = '';
  protestInfo?: ProtestInfo;
  selectedFiler?: FilerType;
  filerId?: number;

  primaryFiles: EPDSFile[] = [];
  associatedFiles: EPDSFile[] = [];
  requiredFileType!: string[];
  attachAssociatedDocOutput?: boolean;
  primaryUploadText = '';
  uploadDocMessage = '';
  fileUploadInProgress = false;
  isDocConfidential?: string;

  intervenorCompNameList?: string[];
  agencyNameList?: string[];
  selectedIntervenorComp?: string;
  selectedAgencyName?: string;
  comments?: string;

  saving = false;

  requestForRecon = [{
    label : 'PROTESTER',
    id :1
  },{
    label : 'INTERVENOR',
    id :2
  },{
    label : 'AGENCY',
    id :3
  }]

  constructor(public readonly stateService: StateService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly protestInfoService: ProtestInfoService,
              private readonly fileUploadService: FileUploadService,
              private readonly sidebarService: SidebarService,
              private util: UtilService) {
  }

  ngOnInit(): void {
    this.typeOfProtest = this.activatedRoute.snapshot.url[0].path;
    this.a_No = this.activatedRoute.snapshot.params['a_No'];

    this.setupFiler();
    this.getMessageForTheTypeOfFilesThisUserCanAttach();

    this.protestInfoService.protestRequest(this.a_No, this.typeOfProtest).subscribe(resp => {
      console.debug(resp);
      this.protestInfo = resp.protestInfo
      this.intervenorCompNameList = resp.intervenorCompNameList;
      this.agencyNameList = resp.agencyNameList;

      if (!resp.intervenorCompNameList || !(resp.intervenorCompNameList.length > 0)) {
        this.requestForRecon = this.requestForRecon.filter(item => item.id != 2);
      }
      this.sidebarService.setNavByUser(this.stateService.user.role_id, resp.protestInfo);
    });

  }

  setupFiler() {
    if (this.typeOfProtest  === 'reconsideration') {
      this.primaryUploadText = 'Request for Reconsideration'
    } else if (this.typeOfProtest  === 'entitlement') {
      this.primaryUploadText = 'Request for Entitlement'
      this.requestForRecon = this.requestForRecon.filter(item => item.id != 2);
    } else {
      this.primaryUploadText = 'Request for Cost Claims'
      this.requestForRecon = this.requestForRecon.filter(item => item.id != 2);
    }

    if (this.stateService.userRole != UserRole.GAO_Admin) {
      this.filerId = 0;
    }

  }

  getMessageForTheTypeOfFilesThisUserCanAttach(){
    if (this.stateService.userRole === UserRole.Protester || this.stateService.userRole === UserRole.Intervenor) {
      this.uploadDocMessage = this.fileUploadService.udmPdfExcel;
      this.requiredFileType = this.fileUploadService.rftPdfExcel;
    } else if (this.stateService.userRole === UserRole.Agency_Admin || this.stateService.userRole === UserRole.Agency_Attorney) {
      this.uploadDocMessage = this.fileUploadService.udmPdfWordExcelZip;
      this.requiredFileType = this.fileUploadService.rftPdfWordExcelZip;
    } else if (this.stateService.userRole === UserRole.GAO_Attorney || this.stateService.userRole === UserRole.GAO_Supervisor) {
      this.uploadDocMessage = this.fileUploadService.udmPdfWordExcel;
      this.requiredFileType = this.fileUploadService.rftPdfWordExcel;
    } else if (this.stateService.userRole === UserRole.GAO_Admin) {
      this.uploadDocMessage = this.fileUploadService.udmPdfWordExcelZip;
      this.requiredFileType = this.fileUploadService.rftPdfWordExcelZip;
    }
  }

  onEPDSFileListChange(epdsFileList: EPDSFile[], typeOfList: string): void {
    console.debug("EPDS File list for type %s: %O", typeOfList, epdsFileList);

    if (typeOfList === 'P') {
      this.primaryFiles = epdsFileList;
    } else {
      this.associatedFiles = epdsFileList;
    }

    console.debug(this.primaryFiles);
    console.debug(this.associatedFiles);
  }

  onAttachAssociatedDocOutput(attach: boolean) {
    this.attachAssociatedDocOutput = attach;
  }

  onFilerChange(event: MatSelectChange) {
    console.debug(event.value);

    const filer: FilerType = event.value;
    this.filerId = filer.id;
  }

  onSubmit(protestForm: any): void {
    console.debug(protestForm.valid);
    console.debug(protestForm.value)

    if (protestForm.valid) {
      const allFiles = [
        ...this.primaryFiles.map(epdsFile => ({epdsFile, attachmentType: 'protest'})),
        ...(this.associatedFiles.map?.length ? this.associatedFiles.map(epdsFile => ({epdsFile, attachmentType: 'protest'})) : [])
      ];

      console.debug(allFiles);
      this.fileUploadInProgress = true;

      this.fileUploadService.submitFile(allFiles, this.a_No, this.fileUpload).pipe(
        tap(resp => console.log('Response from submitFile:', resp)),
        catchError(err => {
          // console.error('Error in submitFile:', err);
          this.fileUploadInProgress = false;
          return throwError(err);
        }),
        finalize(() => this.fileUploadInProgress = false),
      ).subscribe(resp => {
        console.debug(resp);
        this.fileUploadInProgress = false;

        this.registerProtest();
      });
    }
  }

  registerProtest() {
    const filerId = this.filerId ?? 0;
    this.protestInfoService.registerOtherProtests(this.a_No, this.typeOfProtest, this.isDocConfidential, this.comments, filerId, this.selectedAgencyName, this.selectedIntervenorComp).subscribe(otherProtestResp => {
      console.debug(otherProtestResp);
      this.saving = false;

      this.router.navigate([this.util.getDashboardURL()]);
    });
  }

  protected readonly UserRole = UserRole;
}
